export const HardwareReadMethod = {
  Manual: 'manual',
  Msr: 'msr',
  Hid: 'hid',
  Scanner: 'scanner',
  Terminal: 'terminal',
} as const;
export type HardwareReadMethod = (typeof HardwareReadMethod)[keyof typeof HardwareReadMethod];
